/**
 * Reusable animation presets for UI components
 * Apple-style smooth animations with cubic-bezier easing
 */

export const fadeScaleIn = {
  initial: { opacity: 0, scale: 0.96, y: -4 },
  animate: { opacity: 1, scale: 1, y: 0 },
  exit: { opacity: 0, scale: 0.98, y: -2 },
  transition: { duration: 0.15, ease: [0.16, 1, 0.3, 1] as [number, number, number, number] },
};

export const fadeSlideIn = {
  initial: { opacity: 0, y: 4 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 4 },
  transition: { duration: 0.12, ease: [0.16, 1, 0.3, 1] as [number, number, number, number] },
};

export const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.03,
      delayChildren: 0.02,
    },
  },
};

export const itemVariants = {
  initial: { opacity: 0, y: 4 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 4 },
  transition: { duration: 0.12, ease: [0.16, 1, 0.3, 1] as [number, number, number, number] },
};

